module.exports = __webpack_public_path__ + "img/newImg1.25cca133.png";